import { Textarea } from 'shared/ui/Textarea'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep4Props = {
  value: string
  onChange: (value: string) => void
}

export const ActionsStep4 = ({ value, onChange }: IActionsStep4Props) => (
  <div className={styles.descriptionStep}>
    <Textarea
      value={value}
      onChange={onChange}
      placeholder='Enter instructions'
      rows={2}
      className={styles.textarea}
    />
  </div>
)
